angular.module('shared').factory('AssetHashCheckerService', ["$q", "$stateParams", "$http", function($q, $stateParams, $http) {
  var loadDebounced;
  loadDebounced = _.debounce((function(deferred) {
    return $http.get('/asset_hash').then(function(response) {
      return deferred.resolve(response.data);
    }, function(data) {
      return deferred.reject(data);
    });
  }), 500);
  return {
    load: function() {
      var deferred;
      deferred = $q.defer();
      loadDebounced(deferred);
      return deferred.promise;
    }
  };
}]);

angular.module('shared').directive('assetHashChecker', function() {
  return {
    restrict: 'E',
    template: `<div class="assets-outdated-warning" ng-if="outdated">
  <div class="assets-outdated-warning__icon">
    <i class="icon-gear"></i>
  </div>
  <div>
    Clubworx has been updated!
    </br>
    <a href="" ng-click="reload()">Click here to reload the page.</a>
  </div>
</div>`,
    controller: ["$scope", "AssetHashCheckerService", function($scope, AssetHashCheckerService) {
      var checkHashes;
      checkHashes = function() {
        var now;
        now = new Date().getTime();
        if (!$scope.outdated && (!$scope.lastCheckTimetamp || now - $scope.lastCheckTimetamp >= 300000)) {
          return AssetHashCheckerService.load().then(function(hashes) {
            $scope.lastCheckTimetamp = now;
            $scope.outdated = $scope.hashes && ($scope.hashes.application_css !== hashes.application_css || $scope.hashes.application_js !== hashes.application_js);
            return $scope.hashes = hashes;
          });
        }
      };
      document.addEventListener("visibilitychange", function() {
        if (document.visibilityState === "visible") {
          return checkHashes();
        }
      });
      window.setInterval(checkHashes, 300000);
      return $scope.reload = function() {
        return window.location.reload();
      };
    }]
  };
});
